import { useState } from 'react';
import { CustomPaymentTypesApi } from '@/api/clients/custom-payments/custom-payment-types.api';

export const useDeleteCustomPaymentType = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const deleteCustomPaymentType = async (
    organizationId,
    customPaymentTypeId,
  ) => {
    setLoading(true);
    setError(null);

    try {
      const response = await CustomPaymentTypesApi.deleteCustomPaymentType(
        organizationId,
        customPaymentTypeId,
      );
      return response.data?.data;
    } catch (err) {
      const errorMessage =
        err.response?.data?.message || 'Failed to delete custom payment type';
      setError(errorMessage);
      console.error('Error deleting custom payment type:', err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const clearError = () => {
    setError(null);
  };

  return {
    deleteCustomPaymentType,
    loading,
    error,
    clearError,
  };
};
